(function () {
  'use strict';

  var SERUM_HANDLE  = 'serum-restructurant-reparation-caramel-vanille';
  var MASQUE_HANDLE = 'masque-anti-casse-pousse-volume-caramel-vanille';
  var GIFT_HANDLE   = 'shampoing-anti-casse-pousse-caramel-vanille';
  var GIFT_PROP     = '_cadeau_offert';

  var running = false;
  var cachedVariantId = null;

  function getCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function getGiftVariantId() {
    if (cachedVariantId) return Promise.resolve(cachedVariantId);
    return fetch('/products/' + GIFT_HANDLE + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        cachedVariantId = p.variants[0].id;
        return cachedVariantId;
      });
  }

  function cartPost(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function refreshCartUI() {
    // Dawn cart drawer refresh
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
    // Si on est sur la page panier, rechargement
    if (window.location.pathname === '/cart') {
      setTimeout(function () { window.location.reload(); }, 400);
    }
  }

  function checkGift() {
    if (running) return;
    running = true;

    getCart().then(function (cart) {
      var items = cart.items || [];

      var hasSerum  = items.some(function (i) { return i.handle === SERUM_HANDLE; });
      var hasMasque = items.some(function (i) { return i.handle === MASQUE_HANDLE; });
      var shouldGift = hasSerum && hasMasque;

      var giftItem = items.find(function (i) {
        return i.properties && i.properties[GIFT_PROP];
      });

      if (shouldGift && !giftItem) {
        getGiftVariantId().then(function (vid) {
          var props = {};
          props[GIFT_PROP] = '🎁 Offert';
          return cartPost('/cart/add.js', {
            items: [{ id: vid, quantity: 1, properties: props }]
          });
        }).then(function () {
          refreshCartUI();
        }).finally(function () { running = false; });

      } else if (!shouldGift && giftItem) {
        cartPost('/cart/change.js', { id: giftItem.key, quantity: 0 })
          .then(function () {
            refreshCartUI();
          }).finally(function () { running = false; });

      } else {
        running = false;
      }
    }).catch(function () { running = false; });
  }

  // Intercepte tous les appels fetch vers le panier
  var _fetch = window.fetch;
  window.fetch = function (url) {
    var result = _fetch.apply(this, arguments);
    if (typeof url === 'string' && /\/cart\/(add|change|update)/.test(url)) {
      result.then(function () { setTimeout(checkGift, 400); });
    }
    return result;
  };

  // Vérification initiale au chargement de la page
  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(checkGift, 600);
  });
})();
